import { Component, inject } from '@angular/core';
import { GenericModalSources } from '@legacy/common-ui-shared-interfaces';
import {
  getBrandLogoLink,
  getShowMinimalNavigationHelp,
} from '@core/jss-routing';
import {
  getEcmpLogo,
  helpClickedAction,
  logoClickedAction,
} from '@core/navigation-store';
import { Store } from '@ngrx/store';

@Component({
  selector: 'wl-minimal-header-container',
  template: '',
  standalone: true,
})
export class MinimalHeaderContainerComponent {
  readonly #store$ = inject(Store);

  readonly showHelp$ = this.#store$.select(getShowMinimalNavigationHelp);
  readonly ecmpHeader$ = this.#store$.select(getEcmpLogo);
  readonly brandLogoLink$ = this.#store$.select(getBrandLogoLink);

  dispatchHelpAction() {
    this.#store$.dispatch(
      helpClickedAction({
        payload: {
          source: GenericModalSources.CHATBOT,
        },
      })
    );
  }

  onLogoClicked() {
    this.#store$.dispatch(
      logoClickedAction({
        payload: {
          source: GenericModalSources.EXIT_FUNNEL,
        },
      })
    );
  }
}
